// One setup card per destination type.
//
// This replaces a switch in Destinations.tsx whose `default: return null`
// was the quiet failure mode: a destination type with no case rendered an
// EMPTY setup modal. The merchant clicks "Add destination", picks the one
// they want, and gets a blank panel with no error anywhere.
//
// A Record over DestinationType cannot do that. A new destination without a
// card fails to compile here, which is the right place to find out.
//
// The six existing cards still live in Onboarding.tsx, because onboarding
// and the destinations hub share them and create/edit/validation belong in
// one place. New destinations get their own file in this directory, so five
// of them can be built in parallel without touching a shared file.

import type { ComponentType } from "react";
import {
  MetaCapiDestinationCard,
  Ga4DestinationCard,
  KlaviyoDestinationCard,
  TikTokDestinationCard,
  GoogleAdsDestinationCard,
  PinterestDestinationCard,
} from "../Onboarding";
import type { DestinationType } from "../destination-catalog";
// The five destinations added 2026-10-18 live in their own files, so each
// one's PR touches only its own card.
import { MicrosoftAdsDestinationCard } from "./microsoft-ads";
import { SnapchatDestinationCard } from "./snapchat";
import { RedditDestinationCard } from "./reddit";
import { OpenAiAdsDestinationCard } from "./openai-ads";
import { AttentiveDestinationCard } from "./attentive";

// Declared in ./types.ts, not here, because this module imports every card
// and the generated cards build themselves by CALLING tokenDestinationCard at
// module scope. Importing the type from here put TokenDestinationCard in a
// cycle with index.ts and threw at load. Re-exported so existing importers
// are unaffected.
import type { DestinationCardProps } from "./types";
export type { DestinationCardProps };

export const DESTINATION_CARDS: Record<
  DestinationType,
  ComponentType<DestinationCardProps>
> = {
  meta_capi: MetaCapiDestinationCard,
  ga4: Ga4DestinationCard,
  klaviyo: KlaviyoDestinationCard,
  tiktok: TikTokDestinationCard,
  google_ads: GoogleAdsDestinationCard,
  pinterest: PinterestDestinationCard,
  microsoft_ads: MicrosoftAdsDestinationCard,
  snapchat: SnapchatDestinationCard,
  reddit: RedditDestinationCard,
  openai_ads: OpenAiAdsDestinationCard,
  attentive: AttentiveDestinationCard,
};
